import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './ListContainer.module.css';
import ListElementDraggable from '../ListElementDraggable';
import Spinner from '../../../Spinner';
import Icon from '../../../Icon';
import Label from '../../../Label';

const bindClasses = classNameBind.bind(styles);

const ListContainer = ({
  isLoading,
  canDrop,
  isOver,
  list,
  onItemSelect,
  isFrom,
  onDragEnd,
  selected,
  item,
  t,
}) => {
  if (isLoading) return <Spinner className="large" />;
  if (canDrop || isOver) {
    return (
      <div className={bindClasses('drop-zone', { isOver })}>
        <Icon
          name="drop"
          color={isOver ? 'blue' : 'gray'}
          size="large"
        />
        <div className={bindClasses('label')}>
          <Label>{t('Transfer.dropHere')}</Label>
        </div>
      </div>
    );
  }

  return list.map(el => (
    <ListElementDraggable
      id={el.id}
      name={el.name}
      nameCaption={el.nameCaption}
      label={el.label}
      isSelected={el.isSelected}
      disabledTooltipContent={el.disabledTooltipContent}
      key={el.id}
      onSelect={onItemSelect}
      isFrom={isFrom}
      onDragEnd={onDragEnd}
      multipleDragged={selected.count - (el.isSelected ? 1 : 0) > 0}
      count={selected.count}
      hidden={item && el.isSelected && item.isFrom === isFrom}
    />
  ));
};

ListContainer.defaultProps = {
  onItemSelect: () => {},
  onDragEnd: () => {},
  selected: {
    count: 0,
  },
  list: [],
  isLoading: false,
  canDrop: false,
  isOver: false,
  isFrom: false,
  item: null,
};

export default ListContainer;
